export default "__VITE_PUBLIC_ASSET__3b7a7a15__"